import { useQuery } from '@apollo/client';
import { useAuth } from '@guildeducationinc/guild-auth';
import { useMemberTraitsContext } from '@src/context/MemberTraitsContext';
import {
  GET_USER_FUNDING_LIMIT,
  ProfileCompletion_FundingLimitRequest,
  ProfileCompletion_FundingLimit,
} from '@src/graphql/home/queries/getUserFundingLimit';

/**
 * Fetch the user's available Funding Limit via uuid + employer_uuid
 *
 * @packageDocumentation
 */

const formatFundingLimit = (fundingLimit: number | undefined) => {
  if (typeof fundingLimit === 'number') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(fundingLimit);
  }
  return null;
};

const useGetUserFundingLimit = () => {
  const { user } = useAuth();
  const { memberTraits } = useMemberTraitsContext();
  const { data, error, loading } = useQuery<
    ProfileCompletion_FundingLimit,
    ProfileCompletion_FundingLimitRequest
  >(GET_USER_FUNDING_LIMIT, {
    skip: !user?.id || !user?.employerId || !memberTraits?.isTransitionMember,
    variables: {
      uuid: user?.id || '',
      employerUuid: user?.employerId || '',
    },
  });

  return {
    userFundingLimit: formatFundingLimit(
      data?.profileCompletion_getUserFundingLimit.fundingLimitAmount
    ),
    loading,
    error,
  };
};

export default useGetUserFundingLimit;
